import React from 'react';
import cx from 'classnames';
import { getFirstColumnMinWidth } from './ResponsiveTableHelper';
import { renderBodyRow } from './BodyRow';
var ResponsiveTableBody = function (_a) {
    var bodyRef = _a.bodyRef, bodyWidth = _a.bodyWidth, rowMinWidth = _a.rowMinWidth, visibleColumns = _a.visibleColumns, displayedRecords = _a.displayedRecords, tableProps = _a.tableProps, hasScrollLeft = _a.hasScrollLeft, handleExpandRow = _a.handleExpandRow, isRowExpanded = _a.isRowExpanded, checkExpandStateById = _a.checkExpandStateById, changeExpandStateById = _a.changeExpandStateById, expandedRowState = _a.expandedRowState;
    var recordIdField = tableProps.recordIdField, recordChildrenField = tableProps.recordChildrenField, isTableExpandedAllEnabled = tableProps.isTableExpandedAllEnabled, rowExpandable = tableProps.rowExpandable, isSingleExpand = tableProps.isSingleExpand, expandRowCssModifier = tableProps.expandRowCssModifier, customRowExpandRender = tableProps.customRowExpandRender, tableLabel = tableProps.tableLabel, tableId = tableProps.tableId;
    return (<div ref={bodyRef} aria-live="polite" aria-atomic="false" className="c-responsive-table-body-outer">
      <table style={{ width: bodyWidth || '100%', minWidth: rowMinWidth }}>
        {tableLabel && <caption className="u-els-visually-hidden">{tableLabel}</caption>}
        <colgroup>
          {visibleColumns.map(function (column) {
            var _a;
            var totalAvailable = Math.max(bodyWidth || rowMinWidth, rowMinWidth);
            var colWidth = (totalAvailable * getFirstColumnMinWidth(column)) / rowMinWidth;
            return <col key={String((_a = column.field) !== null && _a !== void 0 ? _a : column.cssModifier)} style={{ width: colWidth }}/>;
        })}
        </colgroup>
        <tbody className="c-responsive-table-body">
          {displayedRecords.map(function (record, index) {
            var _a, _b;
            var rowId = (_a = record[recordIdField]) !== null && _a !== void 0 ? _a : index;
            var rowExpandableByRecord;
            var isRowExpandedByRecord = isTableExpandedAllEnabled ? checkExpandStateById(rowId, expandedRowState) : isRowExpanded(rowId);
            var handleExpandRowByRowState = isTableExpandedAllEnabled ? changeExpandStateById : undefined;
            if ((expandedRowState === null || expandedRowState === void 0 ? void 0 : expandedRowState.length) > 0) {
                rowExpandableByRecord = ((_b = record[recordChildrenField]) === null || _b === void 0 ? void 0 : _b.length) > 0;
            }
            return (<React.Fragment key={"row-wrapper-".concat(rowId, "-").concat(isTableExpandedAllEnabled ? index : '')}>
                {renderBodyRow({
                    record: record,
                    rowIndex: index,
                    columns: visibleColumns,
                    handleExpandRow: handleExpandRow,
                    isRowExpanded: isRowExpanded,
                    hasScrollLeft: hasScrollLeft,
                    rowExpandable: rowExpandableByRecord || rowExpandable,
                    recordIdField: recordIdField,
                    handleExpandRowByRowState: handleExpandRowByRowState,
                    checkExpandStateById: checkExpandStateById,
                    expandedRowState: expandedRowState,
                    isSingleExpand: isSingleExpand,
                    tableId: tableId
                })}
                {isRowExpandedByRecord && (<tr aria-label="Expanded details" className={cx('c-responsive-table-expand-row', expandRowCssModifier)}>
                    <td colSpan={visibleColumns.length}>
                      {customRowExpandRender({ record: record, index: index, hasScrollLeft: hasScrollLeft, changeExpandStateById: changeExpandStateById, checkExpandStateById: checkExpandStateById, expandedRowState: expandedRowState })}
                    </td>
                  </tr>)}
              </React.Fragment>);
        })}
        </tbody>
      </table>
    </div>);
};
export default ResponsiveTableBody;
